<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="padding-left-custom-title">
          <span class="uppercase title-app__custom-about">{{ customAboutSingleton.title}}</span>
        </v-col>
        <v-col cols="12" class="pa-0">
          <v-img :src="'https://www.artlesscms.actstudio.xyz/'+customAboutSingleton.cover.path"></v-img>
        </v-col>
      </v-row>
    </v-container>

    <v-container class="py-0 py-sm-3">
      <v-row justify="center">
        <v-col cols="12" sm="11" md="11" lg="10">
          <v-row>
            <v-col cols="12" sm="6">
              <div>
                <span class="d-block mb-5 gtAmerica-bold">{{ customAboutSingleton.title_2 }}</span>
                <div v-html="customAboutSingleton.description" class="custom-about-description-max"></div>
              </div>

              <div>
                <span class="d-block mb-5 gtAmerica-bold">{{ customAboutSingleton.title_4 }}</span>
                <div
                  v-html="customAboutSingleton.description_3"
                  class="custom-about-description-max"
                ></div>
              </div>
            </v-col>
            <v-col cols="12" sm="6">
              <div>
                <span class="d-block mb-5 gtAmerica-bold">{{ customAboutSingleton.title_3 }}</span>
                <div
                  v-html="customAboutSingleton.description_2"
                  class="custom-about-description-max"
                ></div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid class="pb-0">
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-img :src="'https://www.artlesscms.actstudio.xyz/'+customAboutSingleton.cover_2.path"></v-img>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      customAboutSingleton: {},
    };
  },
  beforeMount() {
    //fetch to get the singleton "custom-about"
    fetch(
      "https://www.artlesscms.actstudio.xyz/api/singletons/get/CustomAbout?token=a15be93e9cdb43ca2b3778c2077c26"
    )
      .then((data) => data.json())
      .then((data) => (this.customAboutSingleton = data));
  },
  mounted() {
    var breadcrumbs = [
        {
            text: 'Home',
            link: '/',
            isLink: true
        },
        {
            text: 'Custom',
            link: '/custom',
            isLink: true
        },
        {
            text: 'About',
            link: '/custom/about',
            isLink: false
        }
    ];
    this.$emit("updateStatus", breadcrumbs);
    this.$emit("update", 2);

    gtag('config', 'UA-26953667-1', {
      'page_title' : 'Custom About',
      'page_path': '/custom/about'
    });
  },
};
</script>